import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, useTheme, makeStyles, IconButton, Tooltip } from '@material-ui/core';
import { styles } from './iconBadgeExpandable.styles';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ClippedLabel } from '@globaleris/ui.library';

export interface IconBadgeExpandableProps {
  expanded: boolean;
  name: string;
  faIcon: IconProp;
  abbreviation: string;
  tooltip: string;
  onClick: () => void;
}

const IconBadgeExpandable: React.FC<IconBadgeExpandableProps> = props => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  const icon = <FontAwesomeIcon icon={props.faIcon} className={classes.icon}></FontAwesomeIcon>;

  return (
    <div className={classes.root}>
      {props.expanded ? (
        <div className={classes.expanded}>
          <Tooltip title={props.tooltip}>
            <IconButton onClick={props.onClick}>{icon}</IconButton>
          </Tooltip>
          <ClippedLabel>{props.name}</ClippedLabel>
        </div>
      ) : (
        <div className={classes.collapsed}>
          <Badge badgeContent={props.abbreviation} color="primary" className={classes.badge}>
            {icon}
          </Badge>
        </div>
      )}
    </div>
  );
};

export default IconBadgeExpandable;
